import { render, staticRenderFns } from "./AddSeatsPayDialog.vue?vue&type=template&id=a3f9b320&scoped=true"
import script from "./AddSeatsPayDialog.vue?vue&type=script&lang=js"
export * from "./AddSeatsPayDialog.vue?vue&type=script&lang=js"
import style0 from "./AddSeatsPayDialog.vue?vue&type=style&index=0&id=a3f9b320&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../../../Users/liujianting/manyuTop/ui/comic_ai/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3f9b320",
  null
  
)

export default component.exports